import React, { memo } from 'react'
import PropTypes from 'prop-types'

export const Label = memo(({ hideLabel, id, text }) => (
  <>
    {hideLabel ? null : (
      <label className='dib' htmlFor={id}>
        {text}:&nbsp;
      </label>
    )}
  </>
))

Label.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  hideLabel: PropTypes.bool.isRequired,
}

Label.defaultProps = {
  id: '',
  text: '',
}
